import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("bs_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// Clean auto-logout on an expired/invalid session, instead of letting a stale
// token 401 every request (which crashes the dev build with an overlay).
api.interceptors.response.use(
  (res) => res,
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url || "";
    const isAuthCall = /\/auth\/(login|register|google)/.test(url);
    if (status === 401 && !isAuthCall && localStorage.getItem("bs_token")) {
      localStorage.removeItem("bs_token");
      const path = window.location.pathname;
      if (!path.startsWith("/login") && !path.startsWith("/pay/")) {
        window.location.href = "/login?expired=1";
      }
    }
    return Promise.reject(error);
  }
);

export const fileUrl = (path) =>
  `${API}/files/${path}?auth=${localStorage.getItem("bs_token")}`;

export function apiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (typeof detail === "object" && detail.message) return detail.message;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  return String(detail);
}

// Send the browser to Stripe Checkout. Breaks out of the preview iframe/webview so the
// hosted checkout page (which refuses to be framed) loads in the top-level tab instead of
// showing a blank/grey screen. Safe in production where there is no parent frame.
export function redirectToCheckout(url) {
  if (!url) return;
  try {
    if (window.top && window.top !== window.self) {
      window.top.location.href = url;
      return;
    }
  } catch (e) {
    /* cross-origin parent: fall through to same-frame navigation */
  }
  window.location.href = url;
}

export default api;
